import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { getFilesFromEvent } from '../../lib/get-files-from-event';
import { ToastService } from '../../services/toast.service';

@Directive({
  selector: '[appDragDrop]',
  standalone: true,
})
export class DragDropDirective {
  hoverTimeout: NodeJS.Timeout;
  @Input() disable = false;

  constructor(private toasts: ToastService) {}

  @Output() onFileDropped = new EventEmitter<File[]>();
  @Output() onHover = new EventEmitter<void>();
  @Output() onUnhover = new EventEmitter<void>();

  //Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt: Event) {
    if (this.disable) return;
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      delete this.hoverTimeout;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.onHover.emit();
  }

  //Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt: Event) {
    if (this.disable) return;
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      delete this.hoverTimeout;
    }
    this.hoverTimeout = setTimeout(() => this.onUnhover.emit(), 50);
    evt.preventDefault();
    evt.stopPropagation();
  }

  //Drop listener
  @HostListener('drop', ['$event']) public async ondrop(evt: DragEvent) {
    if (this.disable) return;
    evt.preventDefault();
    evt.stopPropagation();
    this.onUnhover.emit();
    try {
      const files = await getFilesFromEvent(evt);
      this.onFileDropped.emit(files);
    } catch (err) {
      if (err === 'from_web_not_allowed') {
        this.toasts.add('Drag and drop from the web is not yet supported.', 'error', { duration: 3000 });
      } else {
        throw err;
      }
    }
  }
}
